import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class ReportGenerator extends Component {
  constructor(props) {
    super(props);
    this.handleExportClick = this.handleExportClick.bind(this);
  }

  handleExportClick() {
    const {filters} = this.props;
    this.props.downloadInTransitImportsReport(filters);
  }

  render() {
    const {downloading, updating, loading} = this.props;

    return (
      <Button primary
        content='EXPORTAR A EXCEL'
        loading={downloading}
        disabled={downloading || loading || updating}
        onClick={this.handleExportClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'updating': state.providersImportations.updating,
    'loading': state.providersImportations.loading,
    'downloading': state.providersImportations.downloading,
    'filters': state.providersImportations.filters,
  };
};

const {
  downloadInTransitImportsReport,
} = Actions;

export default connect(mapStateToProps, {
  downloadInTransitImportsReport,
})(ReportGenerator);
